export function Footer() {
  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Furgos Río</h3>
            <div className="text-sm text-gray-600 space-y-2">
              <p>Transcaravan Galicia SL</p>
              <p>CIF: B32507808</p>
              <p>Calle Costa Castrelos 2,</p>
              <p>portal 5, 4A</p>
              <p>36213 Vigo, Pontevedra</p>
            </div>
          </div>

          {/* Navigation */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Navegación</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-600 hover:text-brand">Inicio</a></li>
              <li><a href="/campers" className="text-gray-600 hover:text-brand">Nuestras campers</a></li>
              <li><a href="/condiciones-alquiler" className="text-gray-600 hover:text-brand">Condiciones alquiler</a></li>
              <li><a href="/regala" className="text-gray-600 hover:text-brand">Regala Furgos Río</a></li>
              <li><a href="/blog" className="text-gray-600 hover:text-brand">Blog</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><a href="/aviso-legal" className="text-gray-600 hover:text-brand">Aviso legal</a></li>
              <li><a href="/politica-privacidad" className="text-gray-600 hover:text-brand">Política de privacidad</a></li>
              <li><a href="/politica-cookies" className="text-gray-600 hover:text-brand">Política de cookies</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <div className="space-y-2">
              <a 
                href="https://wa.me/34648728151"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-600 hover:text-brand"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
                </svg>
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Furgos Río. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
